import {api} from '../../../system/api';

export default {
    cancelDeliveryNote: (deliveryNoteId) => api.put("delivery-notes/" + deliveryNoteId+"/cancel", {}, {singleRequest: true}),
};
